export default (state, action) => {
	const { payload, type } = action;

	switch (type) {
		case 'SET_USER_AUTH':
			return {
				...state,
				isAuth: payload,
				currentUser: payload,
			};

		default:
			return state;
	}
};
